import './assets/less/screen.less'

import Vue from 'vue'
import VueScroll from 'vuescroll'
import router from './config/router'
import store from './store/index'
import App from './App.vue'
import './config/filters'
import './config/directives'

Vue.use(VueScroll)
Vue.config.productionTip = false
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
// init
async function init () {
  await import(/* webpackChunkName: "view-design" */ './config/view-design')
}

init().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
